/*
 * File: Resource.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 1, 2025 at 10:04 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { tabBarBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	display: flex;
	gap: 24px;
	padding: 40px 0px 60px;
	width: 100%;
	justify-content: center;

	.detailPanel {
		display: none !important;

		@media only screen and (min-width: ${tabBarBreakpoint}em) {
			display: block !important;
		}
	}
`;

export const ResourcePanel = styled.div`
	max-width: 500px;
	padding: 20px 0px 0px;
`;
